import { render, staticRenderFns } from "./branchForm.vue?vue&type=template&id=33666fa1&scoped=true&"
import script from "./branchForm.vue?vue&type=script&lang=js&"
export * from "./branchForm.vue?vue&type=script&lang=js&"
import style0 from "./branchForm.vue?vue&type=style&index=0&id=33666fa1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33666fa1",
  null
  
)

export default component.exports